import { makeStyles } from '@material-ui/core/styles'

export const mapInfoWindowStyles = makeStyles((theme) => ({
  mapInfoContainer: {
    minWidth: 150,
    maxWidth: 378,
    height: 'calc(100dvh - 65px)',
    position: 'absolute',
    padding: 10,
    borderRadius: '0.5rem',
    top: 65,
    left: 55,
    zIndex: 1000,
    overflowY: 'auto',
    background: theme.palette.primary.paper,
    [theme.breakpoints.down('sm')]: {
      top: 110,
      left: 10,
    },
  },
  mapInfoContainerContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  mapInfoCardContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  mapInfoButton: {
    color: 'white',
    background: theme.color.rutgersRed,
    '&:hover': {
      color: 'white',
      background: theme.color.rutgersRed,
    },
  },
  mapInfoFlexContainer: {
    display: 'flex',
  },
  mapInfoMarginRight: {
    marginRight: 10,
  },
  mapInfoDividerStyle: {
    margin: '10px 0px',
  },
  mapInfoTextLabel: {
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto',
    },
  },
  getDirectionsButtonContainer: {
    width: 314,
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  navigateButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  navigateButton: {
    color: 'white',
    background: theme.color.rutgersRed,
    '&:hover': {
      color: 'white',
      background: theme.color.rutgersRed,
    },
  },
  campusContainer: { position: 'absolute', top: '10%', left: '10%' },
  campusImageContainer: {
    paddingBottom: 10,
    width: '290px',
    maxHeight: '205px',
    [theme.breakpoints.down('sm')]: {
      width: '100px',
    },
  },
  campusImage: {
    width: '290px',
    maxHeight: '100%',
    height: 'auto',
    borderRadius: '1rem',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: '150px',
      maxHeight: '100px',
    },
  },
  campusImageText: {
    color: 'white',
    background: theme.color.rutgersRed,
    fontSize: '1.4rem',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
    },
  },
  campusText: {
    fontSize: '1.4rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
    },
  },
  directionsInputContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '0px 0px 10px 0px',
  },
  directionsSubtitle: {
    marginBottom: 10,
  },
  alternateRouteLabel: {
    position: 'relative',
    paddingLeft: 0,
  },
  directionsAddressContainer: { marginTop: 10 },
  originLabel: {
    marginRight: 40,
  },
  destinationLabel: {
    marginRight: 6,
  },
  lotAlertContainer: {
    background: '#cc0033',
    color: 'white',
    padding: '10px 10px',
    margin: '10px 0px',
  },
  mapInfoButtonContainer: {
    marginTop: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  mapInfoTableContainer: {
    marginTop: 10,
    marginBottom: 10,
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  mapInfoTableContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  showDirectionsButtonContainer: {
    height: '100%',
  },
  getDirectionsButton: {
    width: '100%',
    padding: 10,
    borderRadius: '0.5rem',
    color: 'white',
    background: theme.color.rutgersRed,
    '&:hover': {
      color: 'white',
      background: theme.color.rutgersRed,
    },
  },
  getDirectionsButtonText: {
    marginLeft: 5,
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  routeStepsContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
  },
  routeStepsInstructionsContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  routesButtonEnabled: {
    background: theme.palette.base.orange,
    color: '#fff',
    '&:hover': {
      background: theme.palette.base.orange,
    },
  },
  routesButton: {
    color: theme.palette.base.orange,
    borderColor: theme.palette.base.orange,
    background: theme.palette.components.navigationRoutesButton,
    '&:hover': {
      color: theme.palette.base.orange,
      borderColor: theme.palette.base.orange,
      background: theme.palette.components.navigationRoutesButton,
    },
  },
  evChargingIconLabel: {
    fontWeight: 600,
    color: theme.palette.components.linkText,
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.components.linkText,
    },
  },
  hoursContainer: {
    margin: '10px 0',
  },
  noteContainer: {
    backgroundColor: theme.palette.base.brightYellow,
    color: '#000000',
    width: 'auto',
    alignSelf: 'center',
    textAlign: 'center',
    fontWeight: 900,
    padding: '4px 7px',
    margin: '10px 0px',
  },
}))

export default mapInfoWindowStyles
